// extracted by mini-css-extract-plugin
export var blackWithWhiteText = "configurableCta-module--blackWithWhiteText--5fc19";
export var content = "configurableCta-module--content--51d1e";
export var contentWrapper = "configurableCta-module--content-wrapper--56200";
export var copyImageCtaSlice = "configurableCta-module--copy-image-cta-slice--76ae0";
export var descriptionExtraLarge = "configurableCta-module--descriptionExtraLarge--d9ab7";
export var descriptionExtraSmall = "configurableCta-module--descriptionExtraSmall--b0fa1";
export var descriptionLarge = "configurableCta-module--descriptionLarge--ec98b";
export var descriptionMedium = "configurableCta-module--descriptionMedium--7972d";
export var descriptionSmall = "configurableCta-module--descriptionSmall--1a95d";
export var eyebrow = "configurableCta-module--eyebrow--67562";
export var eyebrowExtraLarge = "configurableCta-module--eyebrowExtraLarge--500ba";
export var eyebrowExtraSmall = "configurableCta-module--eyebrowExtraSmall--c4357";
export var eyebrowLarge = "configurableCta-module--eyebrowLarge--30638";
export var eyebrowMedium = "configurableCta-module--eyebrowMedium--54707";
export var eyebrowSmall = "configurableCta-module--eyebrowSmall--d6aad";
export var goldWithBlackText = "configurableCta-module--goldWithBlackText--3b2ec";
export var headlineExtraLarge = "configurableCta-module--headlineExtraLarge--8a8c2";
export var headlineExtraSmall = "configurableCta-module--headlineExtraSmall--9a702";
export var headlineLarge = "configurableCta-module--headlineLarge--8f917";
export var headlineMedium = "configurableCta-module--headlineMedium--2fd0c";
export var headlineSmall = "configurableCta-module--headlineSmall--7dfdc";
export var image = "configurableCta-module--image--474b8";
export var imageLeft = "configurableCta-module--image-left--498dc";
export var imageWrapper = "configurableCta-module--image-wrapper--0eaef";
export var lightGray2WithBlackText = "configurableCta-module--lightGray2WithBlackText--37c7e";
export var link = "configurableCta-module--link--2ea7d";
export var mobileOnly = "configurableCta-module--mobile-only--f8013";
export var pillEyebrow = "configurableCta-module--pill-eyebrow--ba995";
export var seafoam3WithBlackText = "configurableCta-module--seafoam3WithBlackText--d0ede";
export var tanWithBlackText = "configurableCta-module--tanWithBlackText--b18ad";
export var textEyebrow = "configurableCta-module--text-eyebrow--dc93f";
export var whiteWithBlackText = "configurableCta-module--whiteWithBlackText--b20a1";